export const headerConfig = {
  headerTitle: 'Invite Organization',
  headerDescription: 'List of Organization',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
  headerAction1: {
    id: 'invite_admin',
    label: 'Invite Organization',
    icon: 'PlusIcon',
  },
};
